import { createContext, useState, useEffect } from "react";

export const ProfileColPagesssContext = createContext();

export const ProfileColPagesssProvider = ({ children }) => {
  const [profilecolpagesssData, setProfilecolpagesssData] = useState({
    name: "",
    dept: "",
    phone: "",
    office: "",
    profilePhoto: "",
  });

  useEffect(() => {
    const loginUser = JSON.parse(localStorage.getItem("collectorUser"));
    const savedProfile = JSON.parse(localStorage.getItem("collectorProfile"));

   
  let finalData = {};  

  if (loginUser) {
    finalData = {
      name: loginUser.name || "",
      dept: loginUser.dept || "",
      phone: loginUser.phone || "",
      office: loginUser.office || "",
      profilePhoto: loginUser.profilePhoto || "",
    };
  }

    if (savedProfile) {
      finalData = { ...finalData, ...savedProfile };
    }

    setProfilecolpagesssData(finalData);
  }, []);
 

  return (
    <ProfileColPagesssContext.Provider
      value={{ profilecolpagesssData, setProfilecolpagesssData }}
    >
      {children}
    </ProfileColPagesssContext.Provider>
  );
};

export default ProfileColPagesssContext;
